import React, { memo } from 'react';
import { pdfStyles } from '../pdfStyles';
import { Page, Text, View } from '@react-pdf/renderer';
import { Footer, HeaderCompany, PdfLinkifyText } from '.';
import { isEqual } from 'lodash';
import { ColorSet } from 'src/redux/reducers/theme';
import { formatDate } from 'src/utils/misc';

interface AssessmentHeadProps {
  colors: ColorSet;
  assessment: {
    name: string;
    description: string;
    startedDate: string;
    updatedAt: string;
    editedAt?: string;
  };
  exportedBy: string;
  activeWorkspaceName: string;
  label?: string;
  orientation?: 'portrait' | 'landscape';
  id?: string;
}

export const AssessmentHead: React.FC<AssessmentHeadProps> = memo(
  ({ colors, orientation, assessment, exportedBy, activeWorkspaceName, label, id }) => {
    return (
      <Page size={'A4'} wrap style={pdfStyles.page} orientation={orientation} id={id}>
        <HeaderCompany
          companyName={activeWorkspaceName}
          title={assessment.name}
          companyImage={''}
          label={label || 'RISK ASSESSMENT'}
          colors={colors}
        />

        <View style={{ ...pdfStyles.section, flex: 1, justifyContent: 'flex-end' }}>
          <Text style={pdfStyles.gradText}>DESCRIPTION</Text>
          <View style={pdfStyles.spacer1} />
          <PdfLinkifyText style={pdfStyles.p}>{assessment.description || '-'}</PdfLinkifyText>
          <View style={pdfStyles.spacer16} />
          <View style={{ flexDirection: 'row' }}>
            <View style={{ width: 120 }}>
              <Text style={pdfStyles.gradText}>REPORT DATE</Text>
              <View style={pdfStyles.spacer1} />
              <Text style={pdfStyles.p}>{formatDate(new Date(), { emptyValue: '-' })}</Text>
            </View>
            <View style={{ width: 120 }}>
              <Text style={pdfStyles.gradText}>START DATE</Text>
              <View style={pdfStyles.spacer1} />
              <Text style={pdfStyles.p}>{formatDate(assessment.startedDate, { emptyValue: '-' })}</Text>
            </View>
            {assessment.editedAt && (
              <View style={{ width: 120 }}>
                <Text style={pdfStyles.gradText}>EDITED</Text>
                <View style={pdfStyles.spacer1} />
                <Text style={pdfStyles.p}>
                  {formatDate(assessment.editedAt, { emptyValue: '-', formatType: 'datetime' })}
                </Text>
              </View>
            )}
            <View style={{ width: 120 }}>
              <Text style={pdfStyles.gradText}>UPDATED</Text>
              <View style={pdfStyles.spacer1} />
              <Text style={pdfStyles.p}>
                {formatDate(assessment.updatedAt, { emptyValue: '-', formatType: 'datetime' })}
              </Text>
            </View>
            <View>
              <Text style={pdfStyles.gradText}>EXPORTED BY</Text>
              <View style={pdfStyles.spacer1} />
              <Text style={pdfStyles.p}>{exportedBy}</Text>
            </View>
          </View>
        </View>

        <Footer colors={colors} />
      </Page>
    );
  },
  (prevProps, nextProps) => isEqual(prevProps, nextProps),
);
